fx.ns("desktop.common.toolbar", class ToolBarScrollerButton extends shared.stage.ToolBarButton{
    
    constructor(command, component, container){
        super(command, component, container);

        this.items = command.items;
        this.current = command.current;
        
        this._scrollerDisplayed = false;
    }

    create()
    {
        this.scroller = new desktop.common.toolbar.ToolBarScroller(this.command, this.component, this.container);
        this.scroller.visibleAtStart = false;
        
        this.container.addChild( this.scroller );
    }

    onReady()
    {
        super.onReady();
        
        this.on("click",this._click, window);
    }

    destroy()
    {
        super.destroy();

        this.container.removeChild( this.scroller, true );

    }

    _click(event)
    {
        if (!this.enabled)
            return;

        let toolBar = fx.dom.parent(event.target, ".ToolBar");
        if (!toolBar)
            return;

        let target1 = fx.dom.parent(event.target, ".ToolBarScrollerButton");
        let target2 = fx.dom.parent(event.target, ".ToolBarScroller");
        

        if ( (target1 && target1.id == this.id) )
            this.updateScoller(!this.scroller.visible);
        else
        if ( ( !target2 || target2.id != this.scroller.id) && this._scrollerDisplayed )
            this.updateScoller(false);
            
    }

    //_selected(event)
    //{
        //this.container.trigger("selected", { item : event.detail, event : this.event} );
        //this.command( event.detail );
    //}

    updateScoller(show)
    {
        if (show)
        {
            this.scroller.viewport({left:0, top:this.container.realHeight, width : this.container.realWidth});
            this.scroller.show();
            this.addClass("pushed");
        }
        else
        {
            this.scroller.viewport({left:0, top:this.container.realHeight, width : this.container.realWidth, height:"0px"});
            this.scroller.hide();
            this.removeClass("pushed");
        }

        this._scrollerDisplayed = show;
    }

    
});
